import {
  createUser,
  getUser,
  updateUser,
  deleteUser,
  getUsers,
  changePassword,
} from '../../../actions/users';
import React, { useEffect, useState } from 'react';
import styles from './index.module.css';
import Modal from '../../../components/Modal';
import Input from '../../../components/Input';
import Button from '../../../components/Button';
import Confirmation from '../../../components/Confirmation';
import { useDispatch, useSelector } from 'react-redux';
import { createNotification } from '../../../components/Notifications/Notifications';

const UserModal = ({ modal, setModal }) => {
  const dispatch = useDispatch();
  const { item, item_loading } = useSelector((state) => state.users);
  const authUser = useSelector((state) => state.auth.user);
  const isSuperuser = authUser?.superuser;

  const [value, setValue] = useState({
    username: '',
    email: '',
    password: '',
    is_active: true,
    superuser: false,
  });

  const [showConfirm, setShowConfirm] = useState(false);
  const [showPasswordFields, setShowPasswordFields] = useState(false);
  const [passwords, setPasswords] = useState({
    oldpassword: '',
    newpassword: '',
    showOld: false,
    showNew: false,
  });

  useEffect(() => {
    if (modal?.id) {
      dispatch(getUser(modal.id));
    } else {
      setValue({
        username: '',
        email: '',
        password: '',
        is_active: true,
        superuser: false,
      });
    }
  }, [modal?.id]);

  useEffect(() => {
    if (item && modal?.id) {
      setValue({
        username: item.username || '',
        email: item.email || '',
        password: '',
        is_active: item.is_active ?? true,
        superuser: item.superuser ?? false,
      });
    }
  }, [item]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setValue((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async () => {
    let res;
    const { email, is_active, superuser, username } = value;
    if (modal?.id)
      res = await dispatch(updateUser(modal.id, { email, is_active, superuser, username }));
    else res = await dispatch(createUser(value));

    if (res?.success) {
      setModal(false);
      dispatch(getUsers());
    }
  };

  const handleDelete = async () => {
    const res = await dispatch(deleteUser(modal.id));
    console.log('deleteUser response:', res);

    if (res?.success) {
      setShowConfirm(false);
      setModal(false);
      dispatch(getUsers());
    }
  };

  const handlePasswordChange = async () => {
    const newPass = passwords.newpassword?.trim();

    if (!newPass) {
      return createNotification('error', 'Введите новый пароль');
    }

    if (newPass.length < 3) {
      return createNotification('error', 'Пароль должен содержать минимум 3 символа');
    }

    if (/\s/.test(passwords.newpassword)) {
      return createNotification('error', 'Пароль не должен содержать пробелы');
    }
    const payload = {
      username: value.username, // ✅ Меняем именно того, кого редактируем
      oldpassword: passwords.oldpassword,
      newpassword: newPass,
    };

    const res = await dispatch(changePassword(payload));
    if (res?.success) {
      createNotification('success', 'Пароль успешно изменён!');
      setShowPasswordFields(false);
      setPasswords({ oldpassword: '', newpassword: '' });
    } else {
      createNotification('error', res?.error || 'Не удалось изменить пароль');
    }
  };

  return (
    <div className={styles.wrapper}>
      <Modal
        width={700}
        open={modal}
        onClose={() => setModal(false)}
        loading={item_loading}
        title={modal?.id ? 'Редактирование пользователя' : 'Создание пользователя'}
      >
        <form className={styles.form} onSubmit={(e) => e.preventDefault()}>
          <Input
            onChange={handleChange}
            name="username"
            type="text"
            placeholder="Логин"
            value={value.username}
            disabled={!!modal?.id && !isSuperuser && authUser.username !== value.username}
          />

          <Input
            onChange={handleChange}
            name="email"
            type="email"
            placeholder="E-mail"
            value={value.email}
          />

          <div className={styles.switches}>
            <label className={styles.checkbox}>
              <input
                type="checkbox"
                name="is_active"
                checked={value.is_active}
                onChange={handleChange}
              />
              Активен
            </label>

            <label className={styles.checkbox}>
              <input
                type="checkbox"
                name="superuser"
                checked={value.superuser}
                onChange={handleChange}
              />
              Администратор
            </label>
          </div>

          {/* 🔐 Кнопка смены пароля */}
          {modal?.id && (
            <div className={styles.passwordSection}>
              <Button
                text={showPasswordFields ? 'Скрыть смену пароля' : 'Сменить пароль'}
                onClick={() => setShowPasswordFields((p) => !p)}
                type="primary"
              />
            </div>
          )}

          {showPasswordFields && (
            <div className={styles.passwordFields}>
              {!isSuperuser && (
                <Input
                  name="oldpassword"
                  type="password"
                  placeholder="Старый пароль"
                  value={passwords.oldpassword}
                  onChange={(e) => setPasswords((p) => ({ ...p, oldpassword: e.target.value }))}
                />
              )}
              <Input
                name="newpassword"
                type="password"
                placeholder="Новый пароль"
                value={passwords.newpassword}
                onChange={(e) => setPasswords((p) => ({ ...p, newpassword: e.target.value }))}
              />
              <Button text="Сохранить пароль" type="success" onClick={handlePasswordChange} />
            </div>
          )}

          <div className={styles.btns}>
            <Button text={modal?.id ? 'Сохранить' : 'Создать'} onClick={handleSubmit} />
            <Button text="Отмена" onClick={() => setModal(false)} />

            {isSuperuser && modal?.id && (
              <Button text="Удалить" type="danger" onClick={() => setShowConfirm(true)} />
            )}
          </div>
        </form>
      </Modal>

      {showConfirm && (
        <Confirmation
          absolute={true}
          confirmation={`пользователя ${value.username}`}
          color="#222"
          acceptConfirmation={handleDelete}
          rejectConfirmation={() => setShowConfirm(false)}
        />
      )}
    </div>
  );
};

export default UserModal;
